import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';
import {
    createProject,
} from '../models/Project';

export const DEFAULT_PROJECT = {
    description: '',
    end: null,
    id: null,
    name: '',
    start: null,
    submitted: false,
    completed: true,
    url: '',
};
const emptyProjectFactory = () => ({ ...JSON.parse(JSON.stringify(DEFAULT_PROJECT)) });

export const useProjectStore = defineStore('profile-projects', () => {
    const newProject = reactive(emptyProjectFactory());
    const state = reactive({
        projects: [],
    });

    function clearNewRows() {
        const emptyProject = emptyProjectFactory();
        Object.keys(newProject).forEach((key) => {
            newProject[key] = emptyProject[key];
        });
    }

    function deleteProject(id) {
        state.projects = state.projects.filter(x => x.id !== id);
    }

    function updateFromQuery(data) {
        clearNewRows();
        // The default row is merged to make sure all necessary fields are initialized.
        // eslint-disable-next-line no-param-reassign
        state.projects = [
            ...data.map(project => ({
                ...DEFAULT_PROJECT,
                description: project.description,
                end: project.end,
                id: project.id,
                name: project.name,
                start: project.start,
                completed: Boolean(project.end),
                url: project.url,
            })),
        ];
    }

    const count = computed(() => state.projects.length);
    const filled = computed(() => state.projects.length > 0);
    const models = computed(() => [...state.projects, newProject]
        .filter(x => x.id || x.submitted).map(x => createProject(x)));

    return {
        ...toRefs(state),
        newProject,
        updateFromQuery,
        models,
        count,
        filled,
        delete: deleteProject,
        clearNewRows,
    };
});
